import React from 'react';
import { FilterPopover } from './FilterPopoverContainer.styled';

const FilterPopoverContainer = ({
    popoverId,
    showPopOver,
    AnchorEl,
    handleClose,
    top,
    right,
    left,
    children,
}) => {
    return (
        <FilterPopover
            id={popoverId}
            open={showPopOver}
            anchorEl={AnchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            top={top}
            right={right}
            left={left}
        >
            <>{children}</>
        </FilterPopover>
    );
};

export default FilterPopoverContainer;
